import React, { Fragment, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import {
  Box, NavigationLinkGroup, NestedNavigation, ProgressChart, StatusBadge, Text,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useCurrentUser from '@hooks/useCurrentUser'
import useTaskList, { calculateCompletionDecimal } from '@hooks/useTaskList'
import useTaskListSections from '@hooks/useTaskListSections'

import generateNavigationItems from './utils/generateNavigationItems'

interface NavigationProps {
  taskListId: number,
}

const Navigation = (props: NavigationProps) => {
  const { taskListId } = props

  const { pathname } = useLocation()

  const taskListPayload = useTaskList({ id: taskListId })
  const { brand, taskList, taskList: { title } } = taskListPayload

  const taskListSectionsPayload = useTaskListSections({
    filters: {
      task_list_id: taskListId,
    },
  })

  const { filteredTaskListSections } = taskListSectionsPayload

  const navigationItems = useMemo(() => {
    // @ts-expect-error TS2322
    const items = generateNavigationItems({ pathname, taskList, taskListSections: filteredTaskListSections })
    return items
  }, [pathname, taskListId, filteredTaskListSections.length])

  const isBrandOnRedAlert = digObject(brand, 'options.red_alert', false)

  const { isBrandUser } = useCurrentUser()

  return (
    <NestedNavigation>
      <Box padding="large" width="100%" height={132}>
        <ProgressChart
          decimal={calculateCompletionDecimal(taskList)}
          innerRadius="80%"
          outerRadius="100%"
          height={100}
          // @ts-expect-error TS2322
          width={100}
        />
      </Box>

      <Box flexDirection="column" flexShrink={0} paddingX="large">
        {/* Address */}
        <Box
          borderBottom="1px solid"
          borderColor="lineColor"
          flexDirection="column"
          marginBottom="large"
          paddingY="large"
        >
          <Text fontSize="small">{title || 'Loading...'}</Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
            {brand?.title || 'No Brand'}
          </Text>

          {isBrandOnRedAlert && !isBrandUser
           && <StatusBadge color="red" boxProps={{ marginTop: 'medium' }} text="Red Alert" />}
        </Box>
        {/* End Address */}

        {/* Nav */}
        {navigationItems
          && navigationItems.sections.map(section => section.visible && (
            <Fragment key={section.key}>
              {/*
               // @ts-expect-error TS2322 */}
              {section.visible && section.title && <NestedNavigation.SectionHeader title={section.title} maximized />}

              {section.items
                && section.items.map(item => (
                  <NavigationLinkGroup key={item.key} link={item} secondaryNav sidebarMaximized />
                ))}
            </Fragment>
          ))}
        {/* End Nav */}
      </Box>
    </NestedNavigation>
  )
}

export default Navigation
